<template>
  <section class="listing">
    <div class="wrapper" v-if="!loading">
      <div class="swiper" v-if="swiperShows.length > 0">
        <div class="swiper-wrapper">
          <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
          <swiper :options="swiperOption" ref="swiper" class="swipper-content">
            <!-- slides -->
            <!-- <swiper-slide v-for="show in shows.filter(x => x.images)" :key="show.id" :style="`background-image: url(${getImageURL(show)})`"> -->
            <swiper-slide v-for="show in swiperShows" :key="show.id">
              <!-- <div @click="openShow(show)" style="width: 100%; height: 100%; position: relative"> -->
              <!-- <div @click="openShow(show)" class="show-slide"> -->
                <img :src="getImageURL(show)" />
                <div class="show-legend">
                  <div style="flex-grow: 1">
                    <h1>{{ show.name }} <span v-if="show.online && !show.live" class="online">GRAVADO</span><span v-if="show.live" class="live">AO VIVO</span></h1>
                    <h2>{{ show.duration }}min | {{ show.type }}</h2>
                    <h3>{{ formatDate(show) }}</h3>
                  </div>
                  <div v-for="date in show.dates.filter((x, i) => i < 5)" :key="date" class="calendar">
                    <span>{{ getDay(date) }}</span>
                    <span>{{ getMonthText(date) }}</span>
                  </div>
                </div>
              <!-- </div> -->
            </swiper-slide>
            <!-- Optional controls -->
          </swiper>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
          <div class="counter" :class="{'completed': swiperShows.length === 10}">
            {{swiperShows.length}}/10
          </div>
        </div>
      </div>
      <form @submit.prevent class="form form-search" style="padding: 0">
        <div class="form-inputs">
          <div class="form-inputs-line">
            <input v-model="search" type="text" placeholder="Pesquisar..." />
          </div>
        </div>
      </form>
      <div class="form" v-if="error.indexOf('shows') > -1" style="margin: 10px">
        <div class="hint">você esqueceu de selecionar pelo menos um show</div>
      </div>
      <div class="list-select">
        <div v-for="(show) in showList" :key="show.id" class="list" @click="changeStatus(show)">
          <div class="data">
            <div class="main-data">{{ show.name }}</div>
            <div class="detail-data">{{ `${show.duration}min | ${show.type}` }}</div>
          </div>
          <div v-if="show.showcaseBusiness" class="form-action"><i class="fas fa-check"></i></div>
        </div>
      </div>
    </div>
    <button @click="save" class="btn-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { getAllShows, updateShowCase } from '../api/showValidation'

export default {
  data () {
    return {
      shows: [],
      error: [],
      search: '',
      loading: true,
      selectedShows: [],
      swiperOption: {
        grabCursor: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  computed: {
    ...mapState(['business']),
    swiperShows () {
      return this.shows.filter(x => x.showcaseBusiness)
    },
    showList () {
      return this.shows.filter(x => {
        if (
          Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase()))
        ) return x
      })
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      this.shows = await getAllShows(null, this.business.url)
      this.selectedShows = this.shows.filter(x => x.showcaseBusiness).map(x => x.id)
      this.loading = false
    },
    async save () {
      if (this.loading) return
      this.loading = true
      this.error = []
      try {
        await updateShowCase(
          this.shows.filter(x => this.selectedShows.includes(x.id)).map(x => ({ id: x.id, showcase: x.showcase, showcaseBusiness: x.showcaseBusiness, showcaseAll: x.showcaseAll }))
        )
        await this.getData()
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error)
        }
      }
      this.loading = false
    },
    formatDate (show) {
      if (show.dates.length > 1) {
        return `A partir de ${this.getDate(show.dates[0])} ${this.getHours(show.dates[0])}:${this.getMinutes(show.dates[0])}`
      } else {
        return `${this.getDate(show.dates[0])} ${this.getHours(show.dates[0])}:${this.getMinutes(show.dates[0])}`
      }
    },
    getImageURL (show) {
      return `${process.env.VUE_APP_IMG}/${show.business}/${show.id}/${show.images[0]}`
    },
    changeStatus (show) {
      if (this.swiperShows.length < 10) {
        show.showcaseBusiness = !show.showcaseBusiness
        if (!this.selectedShows.includes(show.id)) this.selectedShows.push(show.id)
      } else {
        show.showcaseBusiness = false
        if (!this.selectedShows.includes(show.id)) this.selectedShows.push(show.id)
      }
    }
  }
}
</script>

<style lang="scss">
  .swiper-pagination-bullet {
    margin: 3px;
  }
</style>
<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.counter {
  position: absolute;
  z-index: 1;
  background-color: #fff;
  padding: 10px;
  margin-left: 5vw;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.completed {
    background-color: #28ff33;
  }
}
.btn-save {
  position: fixed;
  bottom: 20px;
  right: 30px;
  color: #fff;
  border: none;
  border-radius: 100px;
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  font-size: 1em;
  font-weight: 400;
  width: auto;
  height: 40px;
  padding: 0 15px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
  i {
    margin-right: 7px;
    animation-name: ticket-save;
    animation-timing-function: ease-in-out;
    animation-duration: 0.8s;
    animation-iteration-count: 5;
  }
}
.wrapper {
  margin-bottom: 50px;
}
.switch {
  margin: 5px auto !important;
}
.swiper {
  display: flex;
  justify-content: center;
}
.form-search {
  flex-direction: row;
  align-items: center;
  padding: 0;
  padding-bottom: 10px;

  .form-inputs {
    width: calc(100% - 10px);
  }

  .form-inputs-line {
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  label {
    margin: 0;
  }
  input, select {
    flex-grow: 1;
    margin: 5px;
  }
}
.form {
  margin: 50px 10px;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.swiper-pagination {
  bottom: 0px;
  left: 0;
  width: 100%;
}

.swiper-wrapper {
  // height: 400px;
  padding-bottom: 15px;
  box-shadow: 0 0 3px 0px #dedede;
}
.swiper-container {
  width: 1000px;
  border-radius: 6px;
}
.banner-festival {
  margin: 35px 0;
  width: 100%;
  cursor: pointer;
}

.shows-section {
  margin-top: $menu-height;
}

.swipper-content {
  box-shadow: none;
}

.swiper-slide {
  // background-size: cover;
  // background-position: center;
  // background-repeat: no-repeat;
  width: 100% !important;
  max-width: 1000px;
  img {
    object-fit: contain;
    width: 1000px;
    max-width: 1000px;
    height: 400px;
    max-height: 400px;
  }
  // max-height: 470px;
  cursor: pointer;
}

.show-legend {
  display: flex;
  align-items: center;
  // width: 100%;
  height: 70px;
  background: #fff;
  padding: 15px 10px;
  border: none;
  // border: 1px solid #ccc;
  margin-top: -3px;
  h1 {
    color: $primary-color;
    // color: #333;
    font-size: 1.4em;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100vw - 20px);
    display: flex;
    align-items: center;
  }
  h2, h3 {
    color: #333;
    font-size: 1em;
    font-weight: 300;
  }
  h2 {
    display: none;
  }
}

.calendar {
  display: none;
  width: 40px;
  height: 40px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  border-radius: 5px;
  margin-left: 5px;
  font-weight: 500;
  span:nth-child(1) {
    font-size: 1.2em;
  }
  span:nth-child(2) {
    font-size: 0.7em;
  }
}

.swiper-slide {
  width: 100% !important;
  max-width: 1000px;
  img {
    object-fit: contain;
    width: 100%;
    max-width: 1000px;
    height: 40vw;
    max-height: 400px;
  }
  // max-height: 470px;
  cursor: pointer;
}
.swiper-button-prev {
  width: 15px;
  height: 25px;
  background-size: 15px 25px;
  visibility: hidden;
}

.swiper-button-next {
  width: 15px;
  height: 25px;
  background-size: 15px 25px;
  visibility: hidden;
}

.business-container {
  display: flex;
  flex-wrap: wrap;
  max-width: $max-width;
  // min-height: 600px;
  // padding: $padding-mobile;
  background-color: #fff;
  // margin: 10px auto 0;
  margin: 0 auto;
  margin-bottom: 50px;
}

.business-info {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  width: 100%;
  color: #333;
  padding: $padding-mobile;
  border-bottom: 1px solid #ccc;

  img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 5px;
    margin-right: 15px;
  }

  span:nth-child(1) {
    display: block;
    font-weight: 400;
    font-size: 1.4em;
  }

  span:nth-child(2), span:nth-child(3) {
    display: block;
    font-weight: 300;
    font-size: 0.9em;
  }

  .business-about {
    display: none;
    margin-top: 20px;
    color: #777;
    font-size: 0.9em;
    font-weight: 400;
    text-align: justify;
  }
}

.shows-container {
  flex-grow: 1;
  padding: $padding-mobile;
  margin-top: 5px;
}

.title {
  font-size: 1.4em;
  font-weight: 400;
  color: $primary-color;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 10px;
}

.shows {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0 -5px;
}

.show {
  width: calc(50% - 10px);
  min-width: 150px;
  height: auto;
  margin: 5px;
  padding-bottom: 5px;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;

  &:hover {
    box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.2);
    transform: scale(1.02);
  }
  a {
    text-decoration: none !important;
  }
}

.show-image {
  width: 100%;
  height: 20vw;
  object-fit: cover;
  border-radius: 5px 5px 0 0;
}

.show-name {
  font-weight: 500;
  color: #555;
  margin: 5px 10px 2px;
}

.show-date {
  font-size: 0.9em;
  font-weight: 400;
  color: #777;
  margin: 2px 10px;
}

.zero-shows {
  display: block;
  max-width: 1000px;
  width: 100%;
  height: auto;
  margin: 0 auto;
}

.no-image {
  // background-image: linear-gradient($primary-color, $secondary-color);
  background-image: linear-gradient($hover-color, #ae72c0);
  object-fit: contain;
  padding: 0 50px;
}

.tabs {
  display: flex;
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
  .tab {
    flex-grow: 1;
    font-size: 1.4em;
    font-weight: 400;
    color: rgba(86, 0, 112, 0.7);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding: 5px 0;
    border-bottom: 3px solid transparent;
    text-align: center;
    transition: border-bottom 0.5s, color 0.5s;
    cursor: pointer;
    &.active {
      color: $primary-color;
      border-bottom: 3px solid $primary-color;
    }
  }
}

.live {
  background-color: red;
  color: #fff;
  font-size: 9px;
  font-weight: 500;
  border-radius: 3px;
  padding: 2px 5px;
  margin-left: 10px;
}

.online {
  background-color: $primary-color;
  color: #fff;
  font-size: 9px;
  font-weight: 500;
  border-radius: 3px;
  padding: 2px 5px;
  margin-left: 10px;
}

.online-legend {
  width: 100%;
  color: #555;
  margin: 0 5px 15px;
}

.online-box {
  font-size: 16px;
  text-align: center;
  color: #560070;
  background: #f1f1f1;
  padding: 20px;
  border-radius: 5px;
}

@media screen and (min-width: 1015px) {
  .shows-section {
    padding-top: 10px;
  }
  .show-legend {
    border: none;
    border-bottom: 1px solid #ccc;
  }
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .form-inputs {
    width: calc(100% - 40px);
  }
  .swiper-slide {
  // background-size: cover;
  // background-position: center;
  // background-repeat: no-repeat;
  width: 100% !important;
  max-width: 1000px;
  img {
    object-fit: contain;
    width: 1000px;
    max-width: 1000px;
    height: 400px;
    max-height: 400px;
  }
  // max-height: 470px;
  cursor: pointer;
}

  .form-inputs-line {
    flex-wrap: nowrap !important;
  }
  .banner-festival {
    margin: 50px 0;
  }
  .swiper-wrapper {
    display: flex;
    justify-content: space-between;
    width: 1100px;
    padding-bottom: 0px;
    box-shadow: none;
  }
  .swipper-content {
    box-shadow: 0 0 3px 0px #dedede;
  }

  .business-container {
    padding-top: 15px;
    flex-wrap: nowrap;
    justify-content: center;
  }

  .business-info {
    order: 2;
    width: 250px !important;
    flex-direction: column;
    text-align: center;
    border-left: 1px solid #ccc;
    border-bottom: none;
    padding: $padding-desktop;
    img {
      width: 100px;
      height: 100px;
      margin: 15px 0;
    }
    .business-about {
      display: block;
    }
  }

  .shows-container {
    margin-top: 0;
  }

  .show-legend {
    padding: 15px;
    h2 {
      display: block;
    }
    h3 {
      display: none;
    }
  }

  .calendar {
    display: flex !important;
  }

  .swiper-pagination {
    bottom: 0;
    width: 100%;
  }
  .swiper-button-prev {
    visibility: visible;
    outline: none;
    // transform: translateX(-50px);
    filter: contrast(0.5);
  }

  .swiper-button-next {
    outline: none;
    filter: contrast(0.5);
    visibility: visible;
  }

  .shows-container {
    padding: $padding-desktop;
  }

  .show {
    width: 225px;
    margin: 5px;
  }

  .show-image {
    width: 100%;
    height: 90px;
  }

  .tabs .tab {
    flex-grow: 0;
    text-align: left;
    margin-right: 20px;
  }
}
</style>
